import React from 'react'
import { motion } from 'framer-motion';
import ResumeCard from './ResumeCard';
import { html, css, boot, figma, js, trello, git, react } from '../../assets';

const Card = ({ src, alt, title }) => {
  return (
    <div className=" border-l-[6px] border-l-black border-opacity-30 shadow-md rounded-lg p-6 flex flex-col items-center text-center transform transition-transform duration-300 hover:scale-105 active:scale-95 cursor-pointer">
      <img src={src} alt={alt} className="w-16 h-16 mb-4" />
      <h3 className="text-xl font-bold text-white mb-2">{title}</h3>
    </div>
  );
};


const Skills = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      <div className="w-full lgl:w-1/2">
        <div className="py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px] uppercase">
            my
          </p>
          <h2 className="text-3xl md:text-4xl font-bold">Skills</h2>
        </div>
        <div className='className="mt-14 w-full flex flex-col gap-6'>
          <div className="overflow-x-hidden">
            <div className="mt-6 lgl:mt-14 w-full  border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
              <ResumeCard
                title="Soft Skills"
                subTitle="My Soft skills"
                result="SOFT"
                des={
                <>
                  <ul>
                    <li>Pemecahan Masalah, Kerja sama tim, Kreativitas, Komunikasi, Pengelolaan dan analisis data, Manajemen Waktu,
                    Adaptif, dan Tanggung Jawab</li>
                  </ul>
                </>
                }
              />
              <ResumeCard
                title="Hard Skills"
                subTitle="My Hard skills"
                result="HARD"
                des={
                <>
                  <ul>
                    <li>UIUX Design, WordPress, Web Dasar HTML, CSS, Javascript, PHP, Python, ReactJS, Bootstrap, Git, dan REST API</li>
                  </ul>
                </>
                }
              />
              <ResumeCard
                title="Bahasa"
                subTitle=""
                result="BAHASA"
                des={
                <>
                  <ul>
                    <li>- Bahasa Indonesia (native)</li>
                    <li>- Bahasa Inggris (novice)</li>
                  </ul>
                </>
                }
              />
            </div>
          </div>
        </div>
      </div>

      <div className="w-full lgl:w-1/2">
        <div className="py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px] uppercase">
          my
          </p>
          <h2 className="text-3xl md:text-4xl font-bold">Skills App</h2>
        </div>
        <div className="flex flex-col gap-6">
          <div className="overflow-x-hidden">
            <div className="flex flex-col gap-4">
              <div className="container mx-auto py-8 px-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                  <Card
                    src={figma}
                    alt="Logo 1"
                    title="Figma"
                  />
                  <Card
                    src={html}
                    alt="Logo 1"
                    title="HTML"
                  />
                  <Card
                    src={css}
                    alt="Logo 2"
                    title="CSS"
                  />
                  <Card
                    src={js}
                    alt="Logo 3"
                    title="JS"
                  />
                  <Card
                    src={boot}
                    alt="Logo 3"
                    title="Bootstrap"
                  />
                  <Card
                    src={react}
                    alt="Logo 3"
                    title="React js"
                  />
                  <Card
                    src={trello}
                    alt="Logo 3"
                    title="Trello"
                  />
                  <Card
                    src={git}
                    alt="Logo 3"
                    title="GIT"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default Skills